import styled from "@emotion/styled";
import theme from "../../styles/theme";
import CTA from "../cta/cta";

export const HeroVimeoBase = styled.section`
  background: rgb(246, 248, 255);
  background: linear-gradient(
    0deg,
    rgba(246, 248, 255, 1) 0%,
    rgba(255, 255, 255, 1) 100%
  );
`;

export const HeroVimeoContainer = styled.div`
  position: relative;
  margin: 0 auto;
  padding: 2rem 1rem;
  max-width: 800px;
`;

export const HeroVimeoContent = styled.div`
  text-align: center;
  color: ${theme.colors.darkBlues[75]};
`;

export const HeroVimeoTitle = styled.h1``;

export const HeroVimeoDescription = styled.div`
  font-size: ${theme.fontSizes[3]};
  line-height: ${theme.leading.relaxed};
`;

export const HeroVimeoEmbed = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9;
  margin: 2rem 0;
`;

export const StyledCTA = styled(CTA)`
  margin-left: auto;
  margin-right: auto;
`;
